import React from "react";
import { useApp } from "../context/AppContext";

export default function Header({ onMenuToggle }) {
  const { state, dispatch } = useApp();
  const { theme, activePage, role } = state;
  const dark = theme === "dark";

  const pageNames = { dashboard: "Dashboard", transactions: "Transactions", insights: "Insights" };

  return (
    <header style={{
      height: 64, display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "0 24px",
      background: dark ? "rgba(10,15,30,0.8)" : "rgba(255,255,255,0.8)",
      backdropFilter: "blur(12px)",
      borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)"}`,
      position: "sticky", top: 0, zIndex: 30,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {/* Mobile menu button */}
        <button onClick={onMenuToggle}
         className="mobile-menu-btn" style={{
          background: "none", border: "none", cursor: "pointer", padding: 4,
          color: dark ? "#94a3b8" : "#64748b", fontSize: 20, display: "none",
        }}>☰</button>

        <div>
          <h1 style={{ margin: 0, fontSize:
             20, fontWeight: 700, color: dark ? "#f1f5f9" : "#0f172a", letterSpacing: "-0.02em" }}>
            {pageNames[activePage]}
          </h1>
          <p style={{ margin: 0, fontSize: 12, 
            color: dark ? "#475569" : "#94a3b8" }}>
            {new Date().toLocaleDateString("en-US",
               { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {/* Role badge */}
        <div style={{
          padding: "5px 12px",
           borderRadius: 20,
          background: role === "admin" ? "rgba(99,102,241,0.15)" : 
          "rgba(16,185,129,0.15)",
          color: role === "admin" ? "#a5b4fc" : "#6ee7b7",
          fontSize: 12, fontWeight: 600, border: 
          `1px solid ${role === "admin" ? "rgba(99,102,241,0.3)" : "rgba(16,185,129,0.3)"}`,
        }}>
          {role === "admin" ? " Admin" : "👁 Viewer"}
        </div>

        {/* Avatar */}
        <div style={{
          width: 36, height: 36, borderRadius: "50%",
          background: "linear-gradient(135deg, #6366f1, #10b981)",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer",
        }}>U</div>
      </div>
    </header>
  );
}
